module.exports = __webpack_public_path__ + "static/media/florida_a_gosto.744c8eb3.png";